import React from "react";
import "./graphenode.css";


const NODE_WIDTH = 280;

const HORIZONTAL_GAP = 60;
const VERTICAL_GAP = 45;

const GRAPH_MARGIN = 30;

const MIN_NODE_HEIGHT = 100;

/* 
    download,
    analyse,
    audio,
    changements
    recherche
    transcription,
    scenario
    simplifier


 * ---------------------------------------------------------
 * GraphNode
 * ---------------------------------------------------------
 */

class GraphNode extends React.Component {

    handleButtonClick = (buttonId) => {

        const {
            node,
            onNodeButtonClick
        } = this.props;

        if (!node.buttons) {
            return;
        }

        const button = node.buttons[buttonId];

        if (!button) {
            return;
        }

        /*
         * Un bouton disabled ne doit pas déclencher
         * le callback.
         */
        if (button.disabled) {
            return;
        }

        if (onNodeButtonClick) {

            onNodeButtonClick(
                node,
                buttonId
            );
        }
    };


    renderButton = (buttonId,text) => {

        const {
            node
        } = this.props;

        if (!node.buttons) {
            return null;
        }

        const button = node.buttons[buttonId];

        /*
         * Bouton absent ou invisible.
         */
        if (!button || !button.visible) {
            return null;
        }

        var title = "";
        if ("title" in button)
            title = this.props.lang === "fr"?button.title.fr:button.title.en;
        else
            if (text === "Play")
                title = this.props.lang === "fr"?"Relancer":"Restart";
            else
                title = text;

        return (
            <button
                key={buttonId}

                type="button"

                className="graph-title-button"

                disabled={button.disabled === true}

                title={title}

                onClick={() =>
                    this.handleButtonClick(buttonId)
                }
            >

                {button.image && (
                    <img
                        src={button.image}
                        alt=""
                        draggable="false"
                    />
                )}

            </button>
        );
    };


    renderContent = () => {

        const {
            node
        } = this.props;


        if (Array.isArray(node.content)) {

            return node.content.map(
                (text, index) => (

                    <div
                        key={index}
                        className="graph-node-line"
                    >
                        {text}
                    </div>

                )
            );
        }


        if (
            node.content !== undefined &&
            node.content !== null
        ) {

            return (
                <div className="graph-node-line">
                    {node.content}
                </div>
            );
        }


        return null;
    };


    renderFooter = () => {

        const {
            node
        } = this.props;


        if (!node.footer) {
            return null;
        }


        /*
         * Barre de progression
         */

        if (
            node.footer.type === "progress"
        ) {

            const value = Math.max(
                0,
                Math.min(
                    100,
                    Number(node.footer.value) || 0
                )
            );


            return (
                <div className="graph-node-footer">

                    <div className="graph-progress">

                        <div
                            className="graph-progress-value"

                            style={{
                                width: `${value}%`,

                                backgroundColor:
                                    node.footer.progressColor ||
                                    "#008000"
                            }}
                        />

                        <div className="graph-progress-text">
                            {value}%
                        </div>

                    </div>

                </div>
            );
        }


        /*
         * Footer texte
         */

        return (
            <div className="graph-node-footer">

                <div
                    className="graph-footer-text"

                    style={{
                        color:
                            node.footer.color ||
                            "#ffffff"
                    }}
                >
                    {this.props.lang==="fr"?node.footer.text.fr:node.footer.text.fr}
                </div>

            </div>
        );
    };


    render() {

        

        const {
            node,
            registerNode
        } = this.props;


        return (
            <div
                ref={(element) =>
                    registerNode(
                        node.id,
                        element
                    )
                }

                className="graph-node"

                style={{
                    left: node.x,
                    top: node.y,
                    width: NODE_WIDTH
                }}
            >

                {/* -------------------------------------------------
                    BARRE DE TITRE
                -------------------------------------------------- */}

                <div
                    className="graph-node-title"

                    style={{
                        backgroundColor:
                            node.titleColor ||
                            "#008000"
                    }}
                >

                    <div className="graph-node-title-text">
                        {this.props.lang === "fr"?node.title.fr:node.title.en}
                    </div>


                    <div className="graph-node-buttons">

                        {this.renderButton("play1","Play")}

                        {this.renderButton("play2","Play")}

                        {this.renderButton("stop","Stop")}

                        {this.renderButton("annuler",this.props.lang==="fr"?"Annuler":"Cancel")}

                    </div>

                </div>


                {/* -------------------------------------------------
                    CONTENU
                -------------------------------------------------- */}

                <div className="graph-node-content">

                    {this.renderContent()}

                </div>


                {/* -------------------------------------------------
                    FOOTER
                -------------------------------------------------- */}

                {this.renderFooter()}

            </div>
        );
    }
}


/*
 * ---------------------------------------------------------
 * Graph
 * ---------------------------------------------------------
 */

export default class Graph extends React.Component {

    constructor(props) {

        super(props);


        this.state = {

            /*
             * Nodes avec leurs positions calculées.
             */
            layout: [],

            /*
             * Taille réelle des nodes.
             */
            sizes: {},

            /*
             * Taille totale du graphe.
             */
            graphWidth: 500,
            graphHeight: 300
        };


        this.nodeRefs = {};

        this.resizeObserver = null;

        this.layoutTimer = null;
    }


    componentDidMount() {

        /*
         * Premier calcul.
         */
        this.calculateLayout();


        /*
         * Observe les changements de taille des cases.
         */
        if (window.ResizeObserver) {

            this.resizeObserver =
                new ResizeObserver(
                    this.handleNodeResize
                );


            Object.values(
                this.nodeRefs
            ).forEach(element => {

                if (element) {
                    this.resizeObserver.observe(
                        element
                    );
                }

            });
        }
    }


    componentDidUpdate(prevProps) {

        /*
         * Les données ont changé.
         */
        if (
            prevProps.nodes !==
            this.props.nodes
        ) {

            this.calculateLayout();
        }


        /*
         * ResizeObserver doit observer les nouveaux
         * éléments après le render.
         */
        if (this.resizeObserver) {

            Object.values(
                this.nodeRefs
            ).forEach(element => {

                if (element) {

                    this.resizeObserver.observe(
                        element
                    );

                }

            });
        }
    }


    componentWillUnmount() {

        if (this.resizeObserver) {

            this.resizeObserver.disconnect();

            this.resizeObserver = null;
        }


        if (this.layoutTimer) {

            cancelAnimationFrame(
                this.layoutTimer
            );

            this.layoutTimer = null;
        }
    }


    /*
     * ---------------------------------------------------------
     * Node DOM
     * ---------------------------------------------------------
     */

    registerNode = (id, element) => {

        if (element) {

            this.nodeRefs[id] = element;

            if (this.resizeObserver) {

                this.resizeObserver.observe(
                    element
                );
            }

        }
        else {

            delete this.nodeRefs[id];
        }
    };


    handleNodeResize = () => {

        /*
         * Evite de faire plusieurs calculs pendant
         * le même cycle du navigateur.
         */
        if (this.layoutTimer) {
            return;
        }


        this.layoutTimer =
            requestAnimationFrame(() => {

                this.layoutTimer = null;

                this.calculateLayout();

            });
    };


    /*
     * ---------------------------------------------------------
     * Mesure des cases
     * ---------------------------------------------------------
     */

    measureNodes = () => {

        const sizes = {};


        Object.keys(
            this.nodeRefs
        ).forEach(id => {

            const element =
                this.nodeRefs[id];


            if (!element) {
                return;
            }


            sizes[id] = {

                width:
                    element.offsetWidth,

                height:
                    Math.max(
                        MIN_NODE_HEIGHT,
                        element.offsetHeight
                    )
            };

        });


        return sizes;
    };


    /*
     * ---------------------------------------------------------
     * Map des nodes
     * ---------------------------------------------------------
     */

    getNodeMap = () => {

        const map = new Map();


        (this.props.nodes || []).forEach(
            node => {

                map.set(
                    node.id,
                    node
                );

            }
        );


        return map;
    };


    /*
     * ---------------------------------------------------------
     * Recherche des racines
     * ---------------------------------------------------------
     *
     * Une racine est un node qui n'est jamais présent
     * dans le "next" d'un autre node.
     */

    findRoots = () => {

        const nodes =
            this.props.nodes || [];


        const children = new Set();


        nodes.forEach(node => {

            if (!node.next) {
                return;
            }


            node.next.forEach(childId => {

                children.add(childId);

            });

        });


        return nodes.filter(
            node =>
                !children.has(node.id)
        );
    };


    /*
     * ---------------------------------------------------------
     * Calcul des niveaux
     * ---------------------------------------------------------
     *
     * Exemple :
     *
     * A
     * |
     * B
     * / \
     * C D
     *
     * A = 0
     * B = 1
     * C = 2
     * D = 2
     */

    calculateLevels = () => {

        const nodes =
            this.props.nodes || [];


        const map =
            this.getNodeMap();


        const levels = {};


        const visit = (
            node,
            level,
            path
        ) => {

            if (!node) {
                return;
            }


            /*
             * Protection contre les cycles.
             */
            if (path.has(node.id)) {
                return;
            }


            /*
             * Si ce node a déjà été placé à un niveau
             * supérieur ou égal, inutile de le recalculer.
             */
            if (
                levels[node.id] !== undefined &&
                levels[node.id] >= level
            ) {

                return;
            }


            levels[node.id] = level;


            if (!node.next) {
                return;
            }


            const newPath =
                new Set(path);

            newPath.add(node.id);


            node.next.forEach(childId => {

                const child =
                    map.get(childId);


                if (child) {

                    visit(
                        child,
                        level + 1,
                        newPath
                    );

                }

            });
        };


        /*
         * Commence par les racines.
         */
        const roots =
            this.findRoots();


        roots.forEach(root => {

            visit(
                root,
                0,
                new Set()
            );

        });


        /*
         * Cas particulier : graphe cyclique ou nodes
         * isolés.
         */
        nodes.forEach(node => {

            if (
                levels[node.id] === undefined
            ) {

                levels[node.id] = 0;

            }

        });


        return levels;
    };


    /*
     * ---------------------------------------------------------
     * Groupe les nodes par colonne.
     * ---------------------------------------------------------
     */

    groupByLevel = levels => {

        const columns = {};


        (this.props.nodes || []).forEach(
            node => {

                const level =
                    levels[node.id];


                if (!columns[level]) {

                    columns[level] = [];

                }


                columns[level].push(
                    node
                );

            }
        );


        return columns;
    };


    /*
     * ---------------------------------------------------------
     * Calcul des positions
     * ---------------------------------------------------------
     */

    calculatePositions = (
        columns,
        sizes
    ) => {

        const positions = [];


        const levels =
            Object.keys(columns)
                .map(Number)
                .sort(
                    (a, b) => a - b
                );


        let graphWidth =
            GRAPH_MARGIN;


        let graphHeight =
            GRAPH_MARGIN;


        levels.forEach(level => {

            const column =
                columns[level];


            /*
             * X de la colonne.
             */
            const x =
                GRAPH_MARGIN +
                level *
                (NODE_WIDTH + HORIZONTAL_GAP);


            /*
             * Hauteur totale de la colonne.
             */
            let columnHeight = 0;


            column.forEach(node => {

                const size =
                    sizes[node.id] || {

                        width:
                            NODE_WIDTH,

                        height:
                            MIN_NODE_HEIGHT
                    };


                columnHeight +=
                    size.height;

            });


            if (column.length > 1) {

                columnHeight +=
                    (column.length - 1) *
                    VERTICAL_GAP;
            }


            /*
             * On laisse une marge identique.
             */
            let y =
                GRAPH_MARGIN;


            column.forEach(node => {

                const size =
                    sizes[node.id] || {

                        width:
                            NODE_WIDTH,

                        height:
                            MIN_NODE_HEIGHT
                    };


                positions.push({

                    ...node,

                    level,

                    x,

                    y,

                    width:
                        NODE_WIDTH,

                    height:
                        size.height

                });


                y +=
                    size.height +
                    VERTICAL_GAP;

            });


            graphWidth =
                Math.max(
                    graphWidth,
                    x +
                    NODE_WIDTH +
                    GRAPH_MARGIN
                );


            graphHeight =
                Math.max(
                    graphHeight,
                    GRAPH_MARGIN +
                    columnHeight +
                    GRAPH_MARGIN
                );

        });


        return {
            positions,
            graphWidth,
            graphHeight
        };
    };


    /*
     * ---------------------------------------------------------
     * Calcul global
     * ---------------------------------------------------------
     */

    calculateLayout = () => {

        const nodes =
            this.props.nodes || [];


        if (nodes.length === 0) {

            this.setState({

                layout: [],

                sizes: {},

                graphWidth: 500,

                graphHeight: 300

            });

            return;
        }


        const sizes =
            this.measureNodes();


        const levels =
            this.calculateLevels();


        const columns =
            this.groupByLevel(
                levels
            );


        const result =
            this.calculatePositions(
                columns,
                sizes
            );


        this.setState({

            layout:
                result.positions,

            sizes,

            graphWidth:
                result.graphWidth,

            graphHeight:
                result.graphHeight

        });
    };


    /*
     * ---------------------------------------------------------
     * Rectangle d'une case
     * ---------------------------------------------------------
     */

    getNodeRect = node => {

        const size =
            this.state.sizes[node.id];


        return {

            x:
                node.x,

            y:
                node.y,

            width:
                size?.width ||
                NODE_WIDTH,

            height:
                size?.height ||
                MIN_NODE_HEIGHT

        };
    };


    /*
     * ---------------------------------------------------------
     * Création d'une connexion
     * ---------------------------------------------------------
     *
     * Connexion orthogonale :
     *
     *       ┌───────┐
     *       │       │
     *       └───────┘
     *          |
     *          |
     *       ┌───────┐
     *       │       │
     *       └───────┘
     */

    createPath = (
        source,
        target
    ) => {

        const s =
            this.getNodeRect(
                source
            );


        const t =
            this.getNodeRect(
                target
            );


        /*
         * Départ : milieu du bord droit.
         */

        const sx =
            s.x + s.width;

        const sy =
            s.y +
            s.height / 2;


        /*
         * Arrivée : milieu du bord gauche.
         */

        const tx =
            t.x;

        const ty =
            t.y +
            t.height / 2;


        /*
         * Cas normal :
         * le node cible est à droite.
         */

        if (tx > sx) {

            const middleX =
                sx +
                (tx - sx) / 2;


            return [
                `M ${sx} ${sy}`,
                `H ${middleX}`,
                `V ${ty}`,
                `H ${tx}`
            ].join(" ");
        }


        /*
         * Sécurité pour les graphes avec cycles.
         */

        const middleX =
            Math.max(
                sx,
                tx
            ) + 30;


        return [
            `M ${sx} ${sy}`,
            `H ${middleX}`,
            `V ${ty}`,
            `H ${tx}`
        ].join(" ");
    };


    /*
     * ---------------------------------------------------------
     * Dessin des connexions
     * ---------------------------------------------------------
     */

    renderConnections = () => {

        const {
            layout
        } = this.state;


        const map =
            new Map();


        layout.forEach(node => {

            map.set(
                node.id,
                node
            );

        });


        const connections = [];


        layout.forEach(source => {

            if (!source.next) {
                return;
            }


            source.next.forEach(
                targetId => {

                    const target =
                        map.get(
                            targetId
                        );


                    if (!target) {
                        return;
                    }


                    connections.push(

                        <path
                            key={
                                `${source.id}-${target.id}`
                            }

                            d={
                                this.createPath(
                                    source,
                                    target
                                )
                            }

                            className="graph-connection"
                        />

                    );

                }
            );

        });


        return connections;
    };


    /*
     * ---------------------------------------------------------
     * Bouton d'une case
     * ---------------------------------------------------------
     */

    handleNodeButtonClick = (
        node,
        buttonId
    ) => {

        if (
            this.props.onNodeButtonClick
        ) {

            this.props.onNodeButtonClick(
                node,
                buttonId
            );

        }
    };


    /*
     * ---------------------------------------------------------
     * Render
     * ---------------------------------------------------------
     */

    render() {

        const {
            layout,
            graphWidth,
            graphHeight
        } = this.state;


        return (

            <div className="graph-container">

                <div className="graph-scroll">

                    <div
                        className="graph-canvas"

                        style={{
                            width:
                                graphWidth,

                            height:
                                graphHeight
                        }}
                    >

                        {/* -----------------------------------------
                            CONNEXIONS
                        ------------------------------------------ */}

                        <svg
                            className="graph-connections"

                            width={
                                graphWidth
                            }

                            height={
                                graphHeight
                            }

                            viewBox={
                                `0 0 ${graphWidth} ${graphHeight}`
                            }
                        >

                            {this.renderConnections()}

                        </svg>


                        {/* -----------------------------------------
                            CASES
                        ------------------------------------------ */}

                        <div className="graph-nodes">

                            {layout.map(node => (

                                <GraphNode

                                    lang = {this.props.lang}
                                    key={
                                        node.id
                                    }

                                    node={
                                        node
                                    }

                                    registerNode={
                                        this.registerNode
                                    }

                                    onNodeButtonClick={
                                        this.handleNodeButtonClick
                                    }

                                />

                            ))}

                        </div>

                    </div>

                </div>

            </div>
        );
    }
}